import React from 'react'
import { Header6 } from 'components/UI/Header'

const SpeakersBlock = ({ name, position, photo, className, photoClassName }) => {
    return (
        <div className={`mb-12 px-4 w-full ${ className}`}>
            <div className={`border-primary border border-solid pr-4 pb-4 mb-4 ${ photoClassName }`}>
                { photo }
            </div>
            <Header6 className="mb-2">{ name }</Header6>
            <p className="text-primary text-sm font-bold">{ position }</p>
        </div>
    )
}

export default SpeakersBlock
